module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_3009.60180c86.png";